import React from "react";
import { geoCentroid } from "d3-geo";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  Annotation,
} from "react-simple-maps";
import states from "us-state-codes";
import { Tooltip } from "antd";

import allStates from "./AllStates.json";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const offsets = {
  // Example offsets if you want to use them later
  // VT: [50, -8],
  // NH: [34, 2],
  // MA: [30, -1],
  // RI: [28, 2],
  // CT: [35, 10],
  // NJ: [34, 1],
  // DE: [33, 0],
  // MD: [47, 10],
  // DC: [49, 21],
};

const MapChart = (BidsByChartData) => {
  const history=useHistory()
  const maxLoadState = BidsByChartData?.data?.reduce(
    (max, itm) => {
      return itm[2] > max.load ? { state: itm[0], load: itm[2] } : max;
    },
    { state: "", load: 0 }
  );

  const GenerateColor = (geo) => {
    const stateCode = states.getStateCodeByStateName(geo?.properties?.name);
    const item = BidsByChartData?.data?.find((itm) => itm[0] === stateCode);
    if (!item) return "lightgray";

    const load = item[2];
    if (load < 10) return "#7DA9C7";
    if (load > 10 && load <= 110) return "#7DA0C0";
    if (load > 110 && load <= 310) return "#6287AA";
    if (load > 310) return "#3e4c5c";

    return "lightgray";
  };

  return (
    <ComposableMap width={1500} projection="geoAlbersUsa">
      <Geographies geography={geoUrl}>
        {({ geographies }) => (
          <>
            {/* Render state shapes with tooltip */}
            {geographies.map((geo, i) => {
              const stateName = geo.properties.name;
              const stateCode = states.getStateCodeByStateName(stateName);
              const item = BidsByChartData?.data?.find(
                (itm) => itm[0] === stateCode
              );
              const load = item ? item[2] : 0;

              return (
                <Tooltip
                  key={geo.rsmKey + "-tooltip"}
                  title={`${stateName} | Total Loads: ${load}`}
                >
                  <Geography
                    id={i}
                    stroke="#FFF"
                    geography={geo}
                    fill={GenerateColor(geo)}
                    style={{
                      default: { outline: "none" },
                      hover: {
                        fill: "#FFD700", // Optional hover color
                        outline: "none",
                        cursor: "pointer",
                      },
                      pressed: { outline: "none" },
                    }}
                      onClick={() => {
    const stateName = geo.properties.name;
    const stateCode = states.getStateCodeByStateName(stateName);
    const item = BidsByChartData?.data?.find((itm) => itm[0] === stateCode);
    const load = item ? item[2] : 0;
    console.log({ stateName, stateCode, load },"Data")
history.push(`/load/state?state=${stateCode}`)
    // Call your function here
    // handleStateClick({ stateName, stateCode, load });
  }}
                  />
                </Tooltip>
              );
            })}

            {/* Optional: Render state labels as text or annotations */}
            {geographies.map((geo, i) => {
              const centroid = geoCentroid(geo);
              const cur = allStates.find((s) => s.val === geo.id);
              if (!cur) return null;

              const fullName = cur.name;
              const isMaxLoadState = fullName === maxLoadState.state;

              return (
                <g key={geo.rsmKey + "-name"}>
                  {centroid[0] > -160 && centroid[0] < -67 ? (
                    Object.keys(offsets).indexOf(cur.id) === -1 ? (
                      <Marker coordinates={centroid}
                      style={{hover:{cursor:'pointer'}}}
                       onClick={() => {
    const stateName = geo.properties.name;
    const stateCode = states.getStateCodeByStateName(stateName);
    const item = BidsByChartData?.data?.find((itm) => itm[0] === stateCode);
    const load = item ? item[2] : 0;
    console.log({ stateName, stateCode, load },"Data")
history.push(`/load/state?state=${stateCode}`)
    // Call your function here
    // handleStateClick({ stateName, stateCode, load });
  }}
                      >
                        <circle
                          r={0}
                          fill={isMaxLoadState ? "#FF5733" : "white"}
                          stroke="black"
                        />
                        <text y="2" fontSize={14} textAnchor="middle">
                          {cur.id}
                        </text>
                      </Marker>
                    ) : (
                      <Annotation
                        subject={centroid}
                        dx={offsets[cur.id][0]}
                        dy={offsets[cur.id][1]}
                      >
                        <text x={4} fontSize={14} alignmentBaseline="middle">
                          {cur.id}
                        </text>
                      </Annotation>
                    )
                  ) : null}
                </g>
              );
            })}
          </>
        )}
      </Geographies>
    </ComposableMap>
  );
};

export default MapChart;
